import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

// ====================== BETS ======================
export async function createBet(data) {
    const response = await api.post('/bets', data);
    return response.data;
}

export async function getBets(params = {}) {
    const response = await api.get('/bets', { params });
    return response.data;
}

export async function getOpenBets(params = {}) {
    const response = await api.get('/bets/open', { params });
    return response.data;
}

export async function getBetById(betId) {
    const response = await api.get(`/bets/${betId}`);
    return response.data;
}

export async function acceptBet(betId, takerAddress) {
    const response = await api.post(`/bets/${betId}/accept`, {
        taker_address: takerAddress,
    });
    return response.data;
}

export async function resolveBet(betId, outcome) {
    const response = await api.post(`/bets/${betId}/resolve`, { outcome });
    return response.data;
}

export async function cancelBet(betId, creatorAddress) {
    const response = await api.post(`/bets/${betId}/cancel?creator_address=${creatorAddress}`);
    return response.data;
}

// ====================== USERS ======================
export async function getUserStats(address) {
    const response = await api.get(`/users/${address}/stats`);
    return response.data;
}

export async function getUserBets(address, params = {}) {
    const response = await api.get(`/users/${address}/bets`, { params });
    return response.data;
}

// ====================== PLATFORM ======================
export async function getPlatformStats() {
    const response = await api.get('/stats');
    return response.data;
}

export async function healthCheck() {
    const response = await api.get('/health');
    return response.data;
}

export default api;
